import { render, staticRenderFns } from "./filtered_wrestler_list.vue?vue&type=template&id=6fc55b32&"
import script from "./filtered_wrestler_list.vue?vue&type=script&lang=js&"
export * from "./filtered_wrestler_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports